export const LOCALE_DEFAULT = 'pt-BR';
//# sourceMappingURL=consts.js.map